import { render, staticRenderFns } from "./ChatHeader.vue?vue&type=template&id=efec4a5e&scoped=true"
import script from "./ChatHeader.vue?vue&type=script&lang=js"
export * from "./ChatHeader.vue?vue&type=script&lang=js"
import style0 from "./ChatHeader.vue?vue&type=style&index=0&id=efec4a5e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "efec4a5e",
  null
  
)

export default component.exports